// extracted by mini-css-extract-plugin
export default {"scaledGrid":"scaled-grid-scaledGrid-nvT224","item":"scaled-grid-item-GZeSy0"};